import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ConcernsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const concerns = [
    'お墓が遠方のため、年に一度行くのも負担になっている',
    '雪深い地域で、お参りや除雪が体力的に難しくなってきた',
    '子どもたちが市外・県外に住んでおり、将来の管理が心配',
    '市営霊園でのルールや改葬の手続きが難しそうで、不安',
    '墓石解体や永代供養塔の費用、解体相場がよく分からない',
  ];

  return (
    <section id="concerns" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-stone-800 mb-4">
            もう、大丈夫！後悔しない<br />
            前向きな墓じまい！！
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="rounded-2xl overflow-hidden shadow-2xl"
          >
            <img
              src="images/89.jpg"
              alt="終活について話し合うご家族"
              className="w-full h-full object-cover"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="space-y-6"
          >
            <div className="bg-stone-50 rounded-xl p-6 border-l-4 border-amber-600">
              <p className="text-stone-700 leading-relaxed">
                「お墓をなくすなんて、ご先祖さまに申し訳ないのではないか」
                <br />
                そのようなお気持ちから、墓じまいに踏み切れず、長いあいだ迷っておられる方が多くいらっしゃいます。
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-stone-800 mb-4">
                一方で、現実的な悩みもあります
              </h3>
              <ul className="space-y-3">
                {concerns.map((concern, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                    className="flex items-start gap-3 text-stone-700"
                  >
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center text-sm font-bold mt-1">
                      {index + 1}
                    </span>
                    <span>{concern}</span>
                  </motion.li>
                ))}
              </ul>
            </div>

            <div className="bg-gradient-to-r from-amber-50 to-stone-50 rounded-xl p-6 border border-amber-200">
              <p className="text-stone-700 leading-relaxed">
                こうした悩みは「誰かに相談する」ことで、少しずつ整理されていきます。
                墓じまいは、<strong className="text-amber-800">「ご先祖さまへの感謝を込めて、今の暮らしに合った形に整える」</strong>ための一つの方法です。
              </p>
            </div>

            <div className="pt-4">
              <p className="text-stone-600 leading-relaxed">
                私たちは、終活の一歩としての墓じまいを、決して急かすことなく、ゆっくりとご説明することを大切にしています。
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ConcernsSection;
